import React from "react"
import AccountLayout from "@/components/AccountLayout"
import Message from "@/components/Message"
import Login from "../components/Login"
import { Text, SimpleGrid } from "@chakra-ui/react"
import { Image } from "@chakra-ui/react"
import EmmeLogo from "../images/emmeLogo.png"
import CallBoxLogo from "../images/callboxLogo.png"
import LaconicLogo from "../images/laconicLogo.png"
import GdahaLogo from "../images/gdahaLogo.png"

export default function LoginView() {
  const gradientBox = <Login />

  const message = (
    <Message>
      <Text variant="register" p="8">
        “Partnering with Blind Insight allowed us to accelerate our roadmap by a
        full year, moving us into new product areas and unlocking revenue faster
        than we could on our own.”
      </Text>

      <Text variant="sm" p="8" pt="4">
        &mdash; Erynn Petersen, CEO, Emme
        <br />
        Former CTO Kessel Run, US Dept. of Defense
      </Text>
      <SimpleGrid
        columns={[1, null, 4]}
        gap="40px"
        p="8"
        alignItems="center"
        justifyContent={{ base: "center", md: "space-between" }}
        mt="4"
      >
        <Image
          width={{ base: "6em", md: "7em" }}
          src={EmmeLogo}
          alt="Emme Logo"
        />
        <Image
          width={{ base: "6em", md: "7em" }}
          src={CallBoxLogo}
          alt="Call Box Logo"
        />
        <Image
          width={{ base: "6em", md: "7em" }}
          src={LaconicLogo}
          alt="Laconic Logo"
        />
        <Image
          width={{ base: "6em", md: "7em" }}
          src={GdahaLogo}
          alt="Gdaha Logo"
        />
      </SimpleGrid>
    </Message>
  )

  return <AccountLayout gradientBox={gradientBox} message={message} />
}
